<div [ngSwitch]="optionsType">
    <div
        class="options dropdown-options"
        *ngSwitchCase="1"
        [ngStyle]="{ 'max-height': maxHeight, 'max-width': maxWidth }"
        [ngClass]="optionsPosition ? optionsPosition : ''"
        infiniteScroll
        [infiniteScrollDistance]="2"
        [infiniteScrollThrottle]="50"
        [scrollWindow]="false"
        (scrolled)="onModalScrollDown()"
    >
        <div
            *ngFor="let item of listItems; let index = index"
            class="text-truncate d-flex"
            [id]="'dropdown-item-' + item[optionValueField]"
            [ngStyle]="{
                background:
                    highlightSelectedValue &&
                    (value && item
                        ? value[optionValueField] === item[optionValueField]
                        : false) &&
                    !item.isHeader
                        ? '#9ed7ff'
                        : '',
                color: item['overrideColor'] ? item['overrideColor'] : '',
            }"
            (click)="setValue(item)"
            (keyup)="setValue(item)"
            (keydown)="setValue(item)"
            [ngClass]="{
                'header-hover': item.isHeader,
                'no-fonts-hover': item[optionLabelField] === 'No fonts added',
            }"
        >
            <span
                style="color: #5e6980"
                [ngClass]="item['icon'] ? item['icon'] + ' icon-block' : ''"
            ></span>

            <span
                *ngIf="item[optionLabelField] === 'No fonts added'"
                style="font-weight: 500; font-size: 14px; padding: 8px"
                class="dropdown-header header-box pl-0"
            >
                {{ item[optionLabelField] }}
            </span>

            <span
                *ngIf="
                    !item.isHeader &&
                    item[optionLabelField] !== 'No fonts added'
                "
                class="hoverable-span d-flex"
                [ngClass]="item?.highlightText ? 'text-primary' : ''"
            >
                {{ item[optionLabelField] }}
                <span class="float-right left-detail">{{
                    item[optionSecondaryLabelField]
                }}</span>
            </span>

            <span
                *ngIf="item.isHeader"
                style="
                    color: grey;
                    text-transform: uppercase;
                    line-height: 15.25px;
                    letter-spacing: 1px;
                    font-weight: 600;
                    font-size: 15px;
                    padding: 8px;
                    display: block;
                "
                class="dropdown-header header-box pl-0"
            >
                {{ item[optionLabelField] }}
            </span>
        </div>

        <div
            *ngIf="isFetchingData"
            class="d-flex justify-content-center align-items-center"
        >
            <div
                class="spinner-border spinner-border-sm text-primary"
                role="status"
            ></div>
        </div>
    </div>

    <div
        class="options dropdown-options"
        *ngSwitchCase="2"
        [ngStyle]="{ 'max-height': maxHeight, 'max-width': maxWidth }"
        [ngClass]="optionsPosition ? optionsPosition : ''"
        infiniteScroll
        [infiniteScrollDistance]="2"
        [infiniteScrollThrottle]="50"
        [scrollWindow]="false"
        (scrolled)="onModalScrollDown()"
    >
        <div *ngIf="optionsHeaderText" class="dropdown-header header-box">
            {{ optionsHeaderText }}
        </div>
        <div
            *ngFor="let item of listItems"
            class="text-truncate list-item"
            [id]="'dropdown-item-' + item[optionValueField]"
            [ngStyle]="{
                background:
                    highlightSelectedValue &&
                    (value && item
                        ? value[optionValueField] === item[optionValueField]
                        : false)
                        ? '#9ed7ff'
                        : '',
                color: item['overrideColor'] ? item['overrideColor'] : '',
            }"
            (click)="setValue(item)"
            (keyup)="setValue(item)"
            (keydown)="setValue(item)"
        >
            <span
                class="text-primary font-weight-600 d-flex justify-content-between"
                *ngIf="value[optionValueField] === item[optionValueField]"
            >
                <span class="d-flex gap-2 align-items-center">
                    {{ item[optionLabelField] }}
                    <img src="/icons/dbc/primary_check.svg" />
                </span>
                <span class="float-right left-detail">{{
                    item[optionSecondaryLabelField]
                }}</span>
            </span>
            <span
                *ngIf="value[optionValueField] !== item[optionValueField]"
                class="d-flex justify-content-between pointer-events-none"
                >{{ item[optionLabelField] }}
                <span class="float-right left-detail pointer-events-none">{{
                    item[optionSecondaryLabelField]
                }}</span>
            </span>
        </div>
        <div
            *ngIf="isFetchingData"
            class="d-flex justify-content-center align-items-center"
        >
            <div class="spinner" role="status"></div>
        </div>
    </div>
</div>
